import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from '../Tooltip';
import { TextWrapper } from './OverflowTip.styled';
const OverflowTip = ({ width, textOnly, children }) => {
    const [isOverflowed, setIsOverflow] = useState(false);
    const textElementRef = useRef(null);
    useEffect(() => {
        if (textOnly)
            return;
        setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }, [textOnly]);
    if (textOnly)
        return children;
    return (_jsx(Tooltip, { title: children, disableHoverListener: !isOverflowed, children: _jsx(TextWrapper, { ref: textElementRef, width: width, children: children }) }));
};
export { OverflowTip };
